module.exports = {"140271400":"经济技术开发区乡级单位"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140271.json
// module id = 284
// module chunks = 0